import { render } from "./NewTargetModal.vue?vue&type=template&id=79e850dc&ts=true"
import script from "./NewTargetModal.vue?vue&type=script&lang=ts"
export * from "./NewTargetModal.vue?vue&type=script&lang=ts"

import "./NewTargetModal.vue?vue&type=style&index=0&id=79e850dc&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__